<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="label">车辆保养</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')"></i>
      </div>
      <div class="desc">提供定期免费车辆保养服务。承租人需按照指定周期到指定站点进行保养，超期未完成需支付违约金。</div>
    </div>
    <div class="ai-box" v-if="tip">
      <span class="ai-tag">AI</span>
      <span class="ai-text">{{ tip }}</span>
    </div>
    <div class="rule-body">
      <div class="flex-row">
        <el-form-item :prop="`${propPrefix}.maintenanceInterval`" class="flex-input" style="margin-bottom: 0;" :rules="getRules(100000, 1000)">
          <el-input
            :value="modelValue.maintenanceInterval"
            @input="updateField('maintenanceInterval', $event)"
            placeholder="请输入"
            size="small"
            v-integer-number
          >
            <template slot="append">公里/次</template>
          </el-input>
        </el-form-item>
        <span class="label-text" style="margin: 0 10px;">超期未完成按照</span>
        <el-form-item :prop="`${propPrefix}.maintenanceOverdueFee`" class="flex-input" style="margin-bottom: 0;" :rules="getRules(1000)">
          <el-input
            :value="modelValue.maintenanceOverdueFee"
            placeholder="请输入"
            size="small"
            v-number:float
            @input="updateField('maintenanceOverdueFee', $event)"
          >
            <template slot="append">元/每超出1000公里</template>
          </el-input>
        </el-form-item>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getRules } from './utils'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
</style>
